/**
 * userInfo
 */

define('services/appmng/get-app-parameter.service',['app'], function (app) {
    return app.factory('getAppParameter', ['HispaceStore','$q', function (HispaceStore,$q) {

        var appParameter = {
        };

        function get () {
            return appParameter.length>0?appParameter:getUp ().then(function (data) {
                return data;
            });
        }
        
        function getWk (callback) {
            return appParameter.length>0?appParameter:getWatchKind (callback);
        }

        function getUp () {
            var defer = $q.defer();
            HispaceStore.getAppParameter({
                data:["kind","onlineGametags","watchKind"],
                lan:'zh_cn'
            }).then(function (res) {
                appParameter = res.kind;
                if(appParameter.length>0){
                    defer.resolve(appParameter);
                }else{
                    defer.reject();
                }
            });
            return defer.promise;
        }
        
        function getWatchKind (callback) {
            HispaceStore.getAppParameter({
                data:["watchKind","kind"],
                lan:'zh_cn'
            }).then(function (res) {
                appParameter = res.watchKind;
                if(typeof callback =='function'){
                        callback();
                }
            });
            return appParameter;
        }
        
        return {
            get: get,
            getUp: getUp,
            getWk:getWk,
            getWatchKind:getWatchKind
        }

    }]);
});


